const localeMap = {
  ru: 'ru-RU',
  en: 'en-US',
  cn: 'zh-CH'
}

export default {
  LANG: window.locale,
  LOCALE: localeMap[window.locale],
  TRANSITION_SPEED: 200,
  FORM_TIMEOUT: 500,
  COOKIE_EXPIRES: 365
}
